export default "__VITE_ASSET__b4d47510__"